export const GET_VOID_REASONS = 'providers/settings/VoidReasons/GET_VOID_REASONS';
export const GET_VOID_REASONS_BY_PAGINATION = 'providers/settings/VoidReasons/GET_VOID_REASONS_BY_PAGINATION';
export const CREATE_VOID_REASON = 'providers/settings/VoidReasons/CREATE_VOID_REASON';
export const DELETE_VOID_REASON = 'providers/settings/VoidReasons/DELETE_VOID_REASON';
